module.exports = __webpack_public_path__ + "img/2.91f85840.jpg";